<template>
  <div class="container rounded bg-white mt-5 mb-5">
    <div class="row">
      <div class="col-md-3 border-right">
        <div class="d-flex flex-column align-items-center text-center p-3 py-5">
          <img
            class="rounded-circle mt-5"
            width="150px"
            src="https://aloha.ideal-dev.fr/img/avatar.jpg"
          /><span class="font-weight-bold">{{ user.cn }}</span
          ><span class="text-black-50">{{ user.mail }}</span
          ><span> </span>
        </div>
      </div>
      <div class="col-md-5 border-right">
        <div class="p-3 py-5">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="text-right">Informations</h4>
            <a
              class="btn btn-primary"
              v-bind:href="conf.server + `/user/` + uid + `/edit`"
              >Editer</a
            >
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="labels">Prénom</label
              ><input
                type="text"
                class="form-control"
                v-bind:value="user.givenName"
                readonly
              />
            </div>
            <div class="col-md-6">
              <label class="labels">Nom</label
              ><input
                type="text"
                class="form-control"
                v-bind:value="user.sn"
                placeholder="surname"
                readonly
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <label class="labels">Téléphone</label
              ><input
                type="text"
                class="form-control"
                v-bind:value="user.telephoneNumber"
                readonly
              />
            </div>
            <div class="col-md-12">
              <label class="labels">Email</label
              ><input
                type="text"
                class="form-control"
                v-bind:value="user.mail"
                readonly
              />
            </div>
            <div class="col-md-12">
              <label class="labels">Description</label
              ><textarea
                class="form-control"
                v-model="user.description"
                readonly
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="p-3 py-5">
          <div
            class="d-flex justify-content-between align-items-center experience"
          >
            <h4>Rôles</h4>
            <b-button v-b-modal.modal-1 variant="primary"
              >Ajouter un rôle</b-button
            >
          </div>
          <br />
          <div class="list-group container">
            <div class="row" v-for="group in groups" :key="group.cn">
              <a
                v-bind:href="`/role/` + group.cn + `/details`"
                type="button"
                class="list-group-item list-group-item-action col-sm-10"
                >{{ group.cn }}</a
              >
              <button v-on:click="removeRole(group.cn)" class="col-2 btn">
                <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <button v-on:click="deleteUser" class="btn btn-danger">Supprimer</button>

    <b-modal ref="my-modal" id="modal-1" hide-footer title="Ajouter un rôle">
      <form method="POST" @submit="sendForm">
        <div class="form-group">
          <label for="inputPassword4">Rôles: *</label>
          <!--<select v-model="group" class="form-control" aria-label="Selectionner un membre">
                        <option v-for="group in allGroups" :key="group" v-bind:value="group.cn">{{ group.cn }}</option>
                    </select>-->
          <el-select
            class="w-100"
            v-model="group"
            filterable
            default-first-option
            placeholder="Selectionner un membre"
          >
            <el-option
              v-for="group in allGroups"
              :key="group"
              :label="group.cn"
              :value="group.cn"
            >
            </el-option>
          </el-select>
        </div>
        <button type="submit" class="btn btn-primary">Ajouter</button>
      </form>
    </b-modal>
  </div>
</template>
<script>
import conf from "../../../../config/api.js";

export default {
  data() {
    return {
      conf: conf,
      uid: "",
      user: {},
      groups: {},
      group: {},
      allGroups: {},
    };
  },
  beforeMount() {
    //
    this.uid = this.$route.params.uid; // recupere l'uid du user
    //console.log(this.$route.params.uid)
    this.axios
      .get(`${conf.server}/api/ldap/user/` + this.uid) // On recupere les infos de l'utilisateurs
      .then((result) => {
        this.user = result.data.data[0]; // On les stocke dans une variable
        //console.log(this.user)
        this.getGroups(this.uid); // On recupere les groupes de l'utilisateur
      })
      .catch((err) => {
        console.log(err);
      });

    this.getAllGroups(); // On recupere tous les groupes
  },
  methods: {
    removeRole: function(cn) { // Fonction pour supprimer un rôle
      console.log(cn);
      if (
        confirm(
          "Êtes-vous sur de vouloir supprimer le rôle " +
            cn +
            " à cet utilisateur ?"
        )
      ) { // On demande confirmation
        this.axios
          .post(`${conf.server}/api/ldap/group/` + cn + `/removeUser`, { // On fait la requete de suppression
            uid: this.uid, // On envoie l'uid de l'utilisateur
          })
          .then((result) => {
            this.getGroups(this.uid); // On recupere les groupes de l'utilisateur
          })
          .catch((err) => {
            alert(err.response.data.message); // On affiche le message d'erreur
            console.log(err);
          });
      }
    },
    hideModal() { // Fonction pour cacher la modal
      this.$refs["my-modal"].hide();
    },
    getGroups: function(uid) { // Fonction pour recuperer les groupes d'un utilisateur
      this.axios
        .get(`${conf.server}/api/ldap/user/` + this.uid + `/groups`) // On fait la requete pour recuperer les groupes
        .then((result) => {
          this.groups = result.data.data; // On les stocke dans une variable
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteUser: function(event) { // Fonction pour supprimer un utilisateur
      event.preventDefault();
      if (confirm("Êtes-vous sur de vouloir supprimer cet utilisateur ?")) { // On demande confirmation
        this.axios
          .delete(`${conf.server}/api/ldap/user/` + this.uid + `/delete`) // On fait la requete de suppression
          .then((result) => {
            window.location.href = `${conf.server}/gestion-user`; // On redirige vers la page de gestion des utilisateurs
          })
          .catch((err) => {
            alert(err.response.data.message); // On affiche le message d'erreur
          });
      }
    },
    getAllGroups: function(event) { // Fonction pour recuperer tous les groupes
      this.axios.get(`${conf.server}/api/ldap/group/all`).then((result) => { // On fait la requete de recuperation des groupes
        this.allGroups = result.data.data;
      });
    },
    sendForm: function(event) { // Fonction pour ajouter un rôle
      event.preventDefault(); // On bloque le comportement par défaut du formulaire

      this.axios
        .post(`${conf.server}/api/ldap/group/` + this.group + `/addUser`, { // On fait la requete d'ajout du rôle
          uid: this.uid,
        })
        .then((result) => {
          this.hideModal(); // On cache la modal
          this.getGroups(); // On recupere les groupes de l'utilisateur
          console.log(result);
        })
        .catch((err) => {
          this.hideModal(); // On cache la modal
          alert(err.response.data.message); // On affiche le message d'erreur
          console.log(err);
        });
    },
  },
};
</script>
